import { CountryTable } from 'components/CountryTable'
import { labelStyles } from 'components/MainComponent/LabelStyles'
import { swissStatsData } from 'components/MainComponent/MainComponent'
import { Textbuilder } from 'components/MainComponent/textBuilder'
import { ReadDataFromWindow } from 'components/WindowCommunication'
import { useLabels } from 'Hooks/useLabels'
import { useState } from 'react'

export const Part4 = ({
  tenant,
  colorMode
}: {
  tenant: Tenant | undefined
  colorMode: 'light' | 'dark' | undefined
}) => {
  const [userValue, setUserValue] = useState<number | undefined>()

  const [userinputs, setUserInputs] = useState<UserInputsType>({})
  const lang = tenant?.lang
  const Labels = useLabels(labelStyles)
  function handleNewData (data: dbDataType) {
    if (data && data.userinputs && data.userinputs.weight)
      setUserInputs(data.userinputs)

    if (
      data &&
      data.userinputs &&
      (data.userinputs.sum || data.userinputs.sum === 0)
    )
      setUserValue(data.userinputs.sum)
  }

  return (
    <>
      <ReadDataFromWindow callback={handleNewData} />

      <p>
        {/* {lang === 'de' ? (
          <>
            Schweizerinnen und Schweizer trinken im internationalen Vergleich
            nicht nur qualitativ hochwertigen Kaffee, sie trinken auch sehr viel
            davon: 8,8 Kilo Rohkaffee werden hierzulande jährlich pro Kopf
            konsumiert. Das entspricht durchschnittlich 3,4 Tassen Café Crème
            aus dem Vollautomaten oder Kapselkaffee täglich.
          </>
        ) : (
          <>
            En comparaison internationale, les Suisses ne boivent
            pas seulement du café de grande qualité, ils en consomment aussi
            beaucoup: 8,8 kilos de café brut sont consommés chaque année par
            habitant dans notre pays. Cela correspond en moyenne à
            3,4 tasses de café par jour.
          </>
        )} */}
        <CountryTable userValue={userValue} lang={tenant?.lang} />{' '}
        {/* {!!userinputs.sum &&
          (lang === 'de'
            ? Textbuilder()
                .add('Sie liegen mit')
                .break()
                .plural(userinputs.sum, {
                  '0': ' Ihren ',
                  '1': ' Ihrer ',
                  '2': ' Ihren '
                })
                .num(userinputs.sum)
                .plural(userinputs.sum, {
                  '0': ' Tassen',
                  '1': ' Tasse',
                  '2': ' Tassen'
                })
                .add('pro Tag also ')
                .break()
                .compare(userinputs.sum, Math.round(swissStatsData.average), {
                  '>': 'über dem',
                  '<': 'unter dem',
                  '=': 'etwa im'
                })
                .add('Schweizer Schnitt.')
                .array()
                .map((m, i) => (
                  <Labels userRelation key={i}>
                    {m}
                  </Labels>
                ))
            : Textbuilder()
                .add('Vous vous situez, avec')
                .break()
                .plural(userinputs.sum, {
                  '0': ' Vos ',
                  '1': ' Votre ',
                  '2': ' Vos '
                })
                .num(userinputs.sum)
                .plural(userinputs.sum, {
                  '0': ' tasses',
                  '1': ' tasse',
                  '2': ' tasses'
                })
                .add(' par jour, ')
                .break()
                .compare(userinputs.sum, Math.round(swissStatsData.average), {
                  '>': 'au-dessus de la moyenne',
                  '<': 'en dessous de la moyenne',
                  '=': 'environ dans la moyenne'
                })
                .add(' suisse.')
                .array()
                .map((m, i) => (
                  <Labels userRelation key={i}>
                    {m}
                  </Labels>
                )))}
        {!!(userinputs.sum === 0) && (
          <>
            <Labels userRelation>
              {lang === 'de' ? (
                <>
                  Sie drücken diesen Schnitt mit Ihrer Kaffee-Abstinenz nach
                  unten.
                </>
              ) : (
                <>
                  Vous poussez cette moyenne vers le bas par votre abstinence
                  de café.
                </>
              )}
            </Labels>
          </>
        )} */}
      </p>
    </>
  )
}
